import React from 'react';
import styles from './unitPrices.module.scss';
import { digitFormatter } from '~/utils';

const UnitPrices = ({ unitPrices }:{ unitPrices: any }) => (
    <div id="unitPrices" className={styles.unitPrices}>
      <h4>Prix unitaires pour bordereau</h4>
      {(unitPrices.withNets.go.unit > 0
        || unitPrices.withNets.rent.unit > 0
        || unitPrices.withNets.back.unit > 0) && <div className={styles.prices}>
        <h5>Avec filet</h5>
        <div className={`${styles.row} ${styles.label}`}>
          <p>Désignation</p>
          <p>Pu net</p>
          <p>Total</p>
        </div>
        {unitPrices.withNets.go.unit > 0
          && <div
            className={styles.row}>
            <p>{unitPrices.withNets.go.label}</p>
            <p>{digitFormatter?.format(unitPrices.withNets.go.unit)} €</p>
            <p>{digitFormatter?.format(unitPrices.withNets.go.total)} €</p>
          </div>
        }
        {unitPrices.withNets.rent.unit > 0
          && <div
            className={styles.row}>
            <p>{unitPrices.withNets.rent.label}</p>
            <p>{digitFormatter?.format(unitPrices.withNets.rent.unit)} €</p>
            <p>{digitFormatter?.format(unitPrices.withNets.rent.total)} €</p>
          </div>
        }
           {unitPrices.withNets.back.unit > 0
          && <div
            className={styles.row}>
            <p>{unitPrices.withNets.back.label}</p>
            <p>{digitFormatter?.format(unitPrices.withNets.back.unit)} €</p>
            <p>{digitFormatter?.format(unitPrices.withNets.back.total)} €</p>
          </div>
        }
      </div>
      }
        {(unitPrices.withoutNets.go.unit > 0
        || unitPrices.withoutNets.rent.unit > 0
        || unitPrices.withoutNets.back.unit > 0) && <div className={styles.prices}>
        <h5>Sans filet</h5>
        <div className={`${styles.row} ${styles.label}`}>
          <p>Désignation</p>
          <p>Pu net</p>
          <p>Total</p>
        </div>
        {unitPrices.withoutNets.go.unit > 0
          && <div
            className={styles.row}>
            <p>{unitPrices.withoutNets.go.label}</p>
            <p>{digitFormatter?.format(unitPrices.withoutNets.go.unit)} €</p>
            <p>{digitFormatter?.format(unitPrices.withoutNets.go.total)} €</p>
          </div>
        }
        {unitPrices.withoutNets.rent.unit > 0
          && <div
            className={styles.row}>
            <p>{unitPrices.withoutNets.rent.label}</p>
            <p>{digitFormatter?.format(unitPrices.withoutNets.rent.unit)} €</p>
            <p>{digitFormatter?.format(unitPrices.withoutNets.rent.total)} €</p>
          </div>
        }
           {unitPrices.withoutNets.back.unit > 0
          && <div
            className={styles.row}>
            <p>{unitPrices.withoutNets.back.label}</p>
            <p>{digitFormatter?.format(unitPrices.withoutNets.back.unit)} €</p>
            <p>{digitFormatter?.format(unitPrices.withoutNets.back.total)} €</p>
          </div>
        }
         {unitPrices.withoutNets?.nets?.unit > 0
          && <div
            className={styles.row}>
            <p>{unitPrices.withoutNets.nets.label}</p>
            <p>{digitFormatter?.format(unitPrices.withoutNets.nets.unit)} €</p>
            <p>{digitFormatter?.format(unitPrices.withoutNets.nets.total)} €</p>
          </div>
        }
      </div>
      }
      <hr/>
    </div>
);

export default UnitPrices;
